import { render, staticRenderFns } from "./CompoundFeed.vue?vue&type=template&id=a23d41a2&scoped=true"
import script from "./CompoundFeed.vue?vue&type=script&lang=js"
export * from "./CompoundFeed.vue?vue&type=script&lang=js"
import style0 from "./CompoundFeed.vue?vue&type=style&index=0&id=a23d41a2&prod&lang=scss&scoped=true"
import style1 from "./CompoundFeed.vue?vue&type=style&index=1&id=a23d41a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23d41a2",
  null
  
)

export default component.exports